import { Container } from "unstated"

import api from "../utils/api"
import deserialize from "../utils/deserialize"
import debounce from "../utils/debounce"

class DiscountsStore extends Container {
  constructor(props) {
    super(props)

    this.fetchDiscounts = debounce(this.fetchDiscounts)
  }

  meta = {
    fetched: false,
  }

  state = {
    discounts: [],
  }

  fetchDiscounts = async skipCheck => {
    if (!skipCheck && this.meta.fetched) return

    this.meta.fetched = true

    try {
      const res = await api.get("/discounts?active=true")
      const discounts = await deserialize(res.data)
      await this.setState({ discounts })
      return discounts
    } catch (e) {
      this.meta.fetched = false
      console.error(e)
    }
  }
}

export default DiscountsStore
